<template>
  <div class="pageHeader">
    <img src="@/assets/logo.png" alt="" class="logo" @click="to_route('/')" />
    <el-input
      placeholder="请输入搜索关键字"
      v-model="inputVal"
      class="search"
      @focus="inputFocus"
    >
      <i
        slot="suffix"
        class="el-input__icon el-icon-search"
        @click="search"
      ></i>
    </el-input>
    <div class="tabs">
      <div
        v-for="i in tabArr"
        :key="i.id"
        class="tab"
        @click="tabClick(i.path)"
      >
        <img :src="i.url" alt="" class="tab_img" />
        <span class="tab_text">{{ i.text }}</span>
      </div>
    </div>
    <div class="mobile">
      <img src="@/assets/image/home_mobile.png" alt="" class="img" />
      <span class="text">手机端</span>
    </div>
    <div class="mine">
      <el-dropdown>
        <span class="el-dropdown-link">
          <img src="@/assets/image/home_mine.png" alt="" class="img" />
          <span class="text">个人中心</span>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="toLogin">个人主页</el-dropdown-item>
          <!-- <el-dropdown-item>我的客服</el-dropdown-item> -->
          <el-dropdown-item @click.native="toLogout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <login-dialog ref="loginDialog" />
      <!-- <login-dialog ref="loginDialog" /> -->
      <!-- <login-dialog ref="loginDialog" /> -->
    </div>
  </div>
</template>

<script>
//例如：import 《组件名称》 from '《组件路径》';
import { removeToken } from "@/utils/auth";
import { isLogin } from "@/utils/common";
console.log(isLogin, "islogin");
export default {
  name: "App",
  components: {},
  data() {
    return {
      inputVal: "",
      isLogin: isLogin(),
      tabArr: [
        {
          id: 0,
          url: require("@/assets/image/home_icon1.png"),
          text: "专科",
          path: "/specialist",
        },
        {
          id: 1,
          url: require("@/assets/image/home_icon2.png"),
          text: "专家",
          path: "/expert",
        },
        {
          id: 2,
          url: require("@/assets/image/home_icon3.png"),
          text: "公益",
          path: "/publicWelfare",
        },
        {
          id: 3,
          url: require("@/assets/image/home_icon4.png"),
          text: "警示",
          path: "/warning",
        },
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    $route(to, from) {
      console.log('路由变化',isLogin())
      this.isLogin= isLogin()
			 
		}
    
  },
  //方法集合
  methods: {
    toLogout() {
      this.$store
        .dispatch("callInterface", {
          url: "/logout",
          method: "post",
        })
        .then((res) => {
          if (res.code === 200) {
            removeToken();
            this.$message.success("退出成功");
            this.$router.push("/home");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    toLogin() {
      console.log(this.isLogin);
      if (this.isLogin) {
        this.$router.push("/personal");
      } else {
        this.$refs.loginDialog.visible = true;
      }
    },
    // 点击搜索输入框
    inputFocus() {
      // this.$router.push('/search')
    },
    search() {
      this.$router.push("/search?inputVal=" + this.inputVal);
    },
    tabClick(path) {
      sessionStorage.removeItem("path");
      this.$router.push(path);
      // window.open("#" + path);
    },
  },
};
</script>

<style lang="scss" scoped>
.pageHeader {
  height: 104px;
  background: #fff;
  display: flex;
  justify-content: center;
  .logo {
    cursor: pointer;
    display: inline-block;
    width: 214px;
    height: 60px;
    margin-top: 21px;
    margin-right: 95px;
  }

  .el-input.search {
    width: 326px;
    height: 42px;
    margin-top: 30px;
    margin-right: 28px;
  }

  ::v-deep .el-input__suffix{
    color: #000;
    font-size: 16px;
    cursor: pointer;
  }

  .tabs {
    display: flex;
    margin-top: 33px;

    .tab {
      width: 86px;
      height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 12px;
      cursor: pointer;

      .tab_img {
        display: inline-block;
        width: 24px;
        height: 24px;
        margin-right: 7px;
      }

      .tab_text {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        color: #000000;
        line-height: 24px;
      }

      &:hover {
        width: 86px;
        height: 36px;
        background: #f5f6f9;
        border-radius: 2px 2px 2px 2px;
      }
    }
  }

  .mobile,
  .mine {
    margin-top: 29px;
    text-align: center;
    cursor: pointer;

    .img {
      display: block;
      width: 28px;
      height: 28px;
      margin: auto;
    }

    .text {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      color: #7b8599;
      line-height: 18px;
    }
  }

  .mobile {
    margin-right: 27px;
  }
}
</style>
<style lang="scss">
.pageHeader {
  .el-input__inner {
    width: 326px;
    height: 42px;
    border-radius: 319px 319px 319px 319px;
    border: 1px solid rgba(0, 0, 0, 0.22) !important;
  }
}
</style>
